import { useQuery } from '@tanstack/react-query';
import { getHolidays } from '../../services/MetaDataService';

const useGetHolidays = (options) =>
    useQuery({
        queryKey: ['holidays'],
        queryFn: () => getHolidays(),
        staleTime: Infinity,
        ...options,
    });

export default useGetHolidays;
